import { z } from "zod";
import { errorCodeSchema } from "../enums.js";

export const apiErrorSchema = z.object({
  error: z.object({
    code: errorCodeSchema,
    message: z.string(),
    details: z.unknown().optional(),
  }),
});

export type ApiError = z.infer<typeof apiErrorSchema>;

export const researchKillSwitchSettingSchema = z.object({
  enabled: z.boolean(),
});

export type ResearchKillSwitchSetting = z.infer<
  typeof researchKillSwitchSettingSchema
>;

export const publicSettingsSchema = z.object({
  research_kill_switch: z.boolean(),
});

export type PublicSettings = z.infer<typeof publicSettingsSchema>;
